export interface Name {
    fr: string;
    en: string;
}

export interface Coordinates {
    type: string;
    coordinates: number[];
}

export interface Address {
    street: string;
    streetName: string;
    number: string;
    postCode: string;
    city: string;
    province: string;
    country: string;
    coordinates: Coordinates;
    typeStreet: string;
    direction: string;
    unit: string;
}

export interface Contact {
    phone: string;
    email: string;
}

export interface SocialMedia {
    facebook: string;
    instagram: string;
    google: string;
    other: string;
}

export interface DailySchedule {
    from: string;
    to: string;
}

export interface Schedule {
    MONDAY: DailySchedule;
    TUESDAY: DailySchedule;
    WEDNESDAY: DailySchedule;
    THURSDAY: DailySchedule;
    FRIDAY: DailySchedule;
    SATURDAY: DailySchedule;
    SUNDAY: DailySchedule;
}

export interface ScheduleItem {
    _id: string;
    type: string;
    schedule: Schedule;
}

export interface Schedules {
    _id: string;
    override: any;
    schedules: ScheduleItem[];
    displaySchedules: boolean;
}

export interface ShopCategory {
    fr: string[];
    en: string[];
}

export interface Keywords {
    fr: string[];
    en: string[];
}

export interface Promotion {
    _id?: string;
    tagDescription: Name;
    fullDescription: Name;
    backgroundColor: string;
    textColor: string;
    icon: string;
    startDate: string;
    endDate?: string;
}

export interface Item {
    _id: string;
    deleted: boolean;
    name: Name;
    description: Name;
    conditions: Condition;
    categoryType: ItemCategoryType;
    isPublic: boolean;
    type: ItemType;
    itemDetails: ItemDetails;
    startSale: string;
    endSale: string | null;
    quantity: number | null;
    quantitySold: number;
    quantityBooked: number;
    fees: Fee;
    itemTaxes: string[];
}

export enum ItemType {
    SUBSCRIPTION = 'SUBSCRIPTION',
    TICKET = 'TICKET',
    DONATION = 'DONATION',
}

export enum ItemCategoryType {
    LEISURE = 'LEISURE',
    LIBRARY = 'LIBRARY',
    SWIMMINGPOOL = 'SWIMMINGPOOL',
    GYM = 'GYM',
    OTHER = 'OTHER',
}

export interface Condition {
    minAge: number | null;
    maxAge: number | null;
    card: CardCondition | null;
    items: string[];
}

export interface CardCondition {
    cardType: CardType | null;
    cardSubType: CardSubType[];
}

export enum CardSubType {
    RESIDENT = 'RESIDENT',
    NONRESIDENT = 'NONRESIDENT',
}
export enum CardType {
    LIBRARY = 'LIBRARY',
    SPORTS = 'SPORTS',
    CITIZEN = 'CITIZEN',
    BCITI = 'BCITI',
    LEGACY = 'LEGACY',
}

export interface ItemDetails {
    cost?: number;
    renewalCost?: number;
    durationType?: DurationType;
    durationDays?: number | null;
    fixedStartDate?: Date | null;
    fixedEndDate?: Date | null;
    renewalDurationDays?: number;
    code?: string;
    inheritance?: SubscriptionItemInheritance;
    subscriptionType?: SubscriptionType;
    category?: SubscriptionCategory;
    cardType?: CardType;
    isLegacyConnector?: boolean;
    customStartDate?: Date | null;
    shortDescription?: Name;
}

export enum DurationType {
    FIXED = 'FIXED', // Vendor configure fixed dates for start and end
    START_TODAY = 'START_TODAY', // Validity starts at the purchase
    START_AT = 'START_AT', // Starts at a date defined by the user
}

export enum SubscriptionCategory {
    DONATION = 'DONATION',
    RE_LEISURE = 'RE-LEISURE',
    RE_LIBRARY = 'RE-LIBRARY',
    RE_OTHER = 'RE-OTHER',
    RE_PARC = 'RE-PARC',
    RE_POOL = 'RE-POOL',
    RE_TENNIS = 'RE-TENNIS',
    NR_LEISURE = 'NR-LEISURE',
    NR_LIBRARY = 'NR-LIBRARY',
    NR_OTHER = 'NR-OTHER',
    NR_PARC = 'NR_PARC',
    NR_POOL = 'NR-POOL',
    NR_TENNIS = 'NR-TENNIS',
}

export interface SubscriptionItemInheritance {
    inheritanceCodes: string[];
    systExtHeritageCode: string;
}

export enum SubscriptionType {
    INDIVIDUAL = 'INDIVIDUAL',
    FAMILIAL = 'FAMILY',
    HERITED = 'HERITED',
}

export interface Fee {
    fixedAmount: number | null;
    percentageAmount: number | null;
    minPrice: number | null;
    maxPrice: number | null;
}

export interface Shop {
    _id: string;
    name: Name;
    description: Name;
    gatewayToken: string | null;
    organisations: string[];
    website: string;
    onHomepage: boolean;
    order: number;
    timezone: string;
    likes: number;
    pictures: string[];
    icon: string;
    shopCategory: ShopCategory;
    deleted: boolean;
    items: Item[];
    taxNumbers: any[];
    promotions: Promotion[];
    address: Address;
    contact: Contact;
    socialMedia: SocialMedia;
    schedules: Schedules;
    keywords: Keywords;
}

export interface Vendor {
    _id: string;
    name: Name;
    allowedOrganisation: string[];
    deleted: boolean;
    shops: Shop[];
    __v: number;
}
